import { defineMessages } from "react-intl";

export const messages = defineMessages({
	status: {
		id: "ktx.patient_list.status",
		defaultMessage: "Státusz"
	},
	name: {
		id: "ktx.patient_list.name",
		defaultMessage: "Név"
	},
	dialysisCentre: {
		id: "ktx.patient_list.dialysis_centre",
		defaultMessage: "Dialízis centrum"
	},
	socialSecurityNumber: {
		id: "ktx.patient_list.social_security_number",
		defaultMessage: "TAJ szám"
	},

	ageLabel: {
		id: "ktx.patient_list.age",
		defaultMessage: "Életkor"
	},
	ageUnit: {
		id: "ktx.patient_list.age_unit",
		defaultMessage: "éves"
	},
	sex: {
		id: "ktx.patient_list.sex",
		defaultMessage: "Nem"
	},
	city: {
		id: "ktx.patient_list.city",
		defaultMessage: "Város"
	},
	weight: {
		id: "ktx.patient_list.weight",
		defaultMessage: "Súly"
	},
	bloodGroup: {
		id: "ktx.patient_list.bloodGroup",
		defaultMessage: "Vércsoport"
	},

	waitingListLabel: {
		id: "ktx.patient_list.waiting_list_label",
		defaultMessage: "ET várólistán"
	},
	waitingListDaysUnitDesktop: {
		id: "ktx.patient_list.waiting_list_days_unit_desktop",
		defaultMessage: "napja"
	},
	waitingListMonthsUnitDesktop: {
		id: "ktx.patient_list.waiting_list_months_unit_desktop",
		defaultMessage: "hónapja"
	},
	waitingListDaysUnitMobile: {
		id: "ktx.patient_list.waiting_list_days_unit_mobile",
		defaultMessage: "napja várólistán"
	},
	waitingListMonthsUnitMobile: {
		id: "ktx.patient_list.waiting_list_months_unit_mobile",
		defaultMessage: "hónapja várólistán"
	},

	assignedUserLabel: {
		id: "ktx.patient_list.assigned_user_label",
		defaultMessage: "Véleményező orvos"
	},
	assignTime: {
		id: "ktx.patient_list.assign_time",
		defaultMessage: "Véleményezésre küldve"
	},
	statusByNephrologist: {
		id: "ktx.patient_list.status_by_nephrologist",
		defaultMessage: "Nefrológus véleménye"
	},
	modifTime: {
		id: "ktx.patient_list.modif_time",
		defaultMessage: "Utolsó módosítás"
	}
});
